<template>
  <header id="site-header" :class="{ top: isHome }">
    <div class="site-header-inner container">
      <h1 class="site-name">
        <nuxt-link to="/">
          <img
            src="/images/logo.png"
            class="site-logo"
            alt="こくちーずスペース"
          />
        </nuxt-link>
      </h1>
      <nav class="global-nav">
        <ul>
          <li><nuxt-link to="/s/">セミナー会場を探す</nuxt-link></li>
          <li><nuxt-link to="/summary/">イベント会場まとめ</nuxt-link></li>
          <li><nuxt-link to="/station/">駅・路線から探す</nuxt-link></li>
          <li class="contact">
            <a href="/request/" target="_blank">
              <span class="contact-note">未掲載の施設の登録はこちらから</span
              ><br />
              <span class="contact-text">掲載リクエストフォーム</span>
            </a>
          </li>
        </ul>
      </nav>
      <button id="nav-toggle" @click="toggle" class="toggle-button">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <kcs-search-header v-if="!isHome && !$device.isMobile" />
  </header>
</template>

<script>
import KcsSearchHeader from '~/components/organisms/kcs-search-header.vue'
export default {
  components: {
    KcsSearchHeader
  },
  props: {
    isHome: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggle() {
      this.$emit('toggle')
    }
  }
}
</script>
